<template>
  <div class="">
    <div class="text-sm font-semibold z-10 lg:z-0 flex items-center cursor-pointer navbar__search"
         @click="showSearch()">
      <svg class="inline-flex m-r-12 w-16 h-16 fill-current">
        <use xlink:href="#lens"></use>
      </svg>
      <span class="hidden md:inline">Ricerca</span>
    </div>
    <transition name="fade">
      <div v-if="show"
           class="fixed lg:absolute left-0 top-0 bg-white shadow-2xl overflow-y-auto z-30 rounded-8 max-h-90vh w-full lg:w-50vw xl:w-40vw">
        <div class="sticky top-0 bg-white z-10 p-x-16">
          <form @submit.prevent="handleSubmit"
                class="flex justify-between p-t-16 items-center">
            <div class="bg-black-100 rounded-4 relative flex-grow-1 w-full flex items-center p-8">
              <svg class="text-black-200 w-20 h-20 fill-current">
                <use xlink:href="#lens"></use>
              </svg>
              <input id="search-lonely-planet-input"
                     ref="searchInput"
                     v-model="searchInput"
                     name="q"
                     tabindex="0"
                     autocapitalize="none"
                     autocomplete="off"
                     autocorrect="off"
                     spellcheck="false"
                     required
                     @input="getSearchData()"
                     class="input border-0 text-base font-semibold w-full m-y-auto m-x-8 appearance-none outline-none bg-transparent">
            </div>
            <button type="button"
                    tabindex="0"
                    class="p-l-8 z-1 text-black-300 hover:text-black-400 w-24 h-24"
                    @click="show=false">
              <svg class="w-24 h-24 fill-current">
                <use xlink:href="#close"></use>
              </svg>
            </button>
          </form>
          <hr class="m-t-16 h-4 text-black-200">
        </div>
        <div class="p-x-16 md:p-x-32"
             ref="searchResult">
          <transition name="fade"
                      mode="out-in">
            <div v-if="loading"
                 :key="1"
                 class="flex flex-row justify-center w-full p-b-16">
              <svg class="m-r-4 w-32 h-32 animate-spin"
                   viewBox="0 0 100 101"
                   fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#fff"/>
                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="#0057d9"/>
              </svg>
            </div>
            <div v-else
                 :key="2"
                 class="flex flex-col gap-y-48 p-y-12">
              <template v-if="items.product">
                <div class="block relative">
                  <div class="flex flex-row justify-between items-center">
                    <div class="block relative">
                      <h3 class="font-display text-lg font-semibold">
                        Guide e prodotti
                      </h3>
                      <p class="text-micro text-black-300">{{ items.product.length }} record {{
                          finded(items.product.length)
                        }}</p>
                    </div>
                    <a class="lpbutton lpbutton-white lpbutton-xs"
                       :href="link">
                      Mostra tutti i risultati
                    </a>
                  </div>
                  <ul class="m-t-6">
                    <li v-for="product in items.product.slice(0,3)"
                        :key="product.id"
                        class="flex flex-row w-full gap-x-4 p-x-12 p-y-16 text-left border-b-1 border-black-200">
                      <div class="flex-w-56">
                        <div class="relative w-full h-full">
                          <a :href="product.link"
                             target="_blank"
                             class="block">
                            <template v-if="product.image">
                              <img :data-src="product.image"
                                   :alt="product.caption"
                                   class="float-left object-cover object-position-center w-56 max-w-56 m-r-16 rounded-4 lazyload">
                            </template>
                            <template v-else>
                              <div class="flex items-center justify-center w-56 h-80 bg-black-100 m-r-16 rounded-8">
                                <svg class="text-black-200 w-20 h-20 fill-current">
                                  <use xlink:href="#book"></use>
                                </svg>
                              </div>
                            </template>
                          </a>
                        </div>
                      </div>
                      <div class="flex-grow-1 flex flex-col justify-center">
                        <h4 class="text-xs text-black-300 m-b-2">
                          {{ product.type }}
                          <template v-if="product.collection==='chapter'">
                            • <span class="font-normal">Capitolo in PDF</span>
                          </template>
                        </h4>
                        <a :href="product.link"
                           target="_blank"
                           class="block">
                          <h3 class="font-semibold text-base leading-tight text-black-500">
                            {{ product.title }}
                          </h3>
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </template>
              <template v-if="items.extras">
                <div class="block relative">
                  <div class="flex flex-row justify-between items-center">
                    <div class="block relative">
                      <h3 class="font-display text-lg font-semibold">
                        Speciali
                      </h3>
                      <p class="text-micro text-black-300">{{ items.extras.length }} record {{
                          finded(items.extras.lenght)
                        }}</p>
                    </div>
                    <a class="lpbutton lpbutton-white lpbutton-xs"
                       :href="link">
                      Mostra tutti i risultati
                    </a>
                  </div>
                  <ul class="m-t-6">
                    <template v-if="items.extras">
                      <li v-for="extra in items.extras.slice(0,3)"
                          :key="extra.id"
                          class="w-full p-x-12 p-y-16 text-left border-b-1 border-black-200">
                        <a :href="extra.link"
                           target="_blank"
                           class="relative flex flex-row">
                          <template v-if="extra.image">
                            <img :data-src="extra.image"
                                 :alt="extra.title"
                                 class="float-left object-cover object-position-center w-56 h-56 max-w-56 m-r-16 rounded-8 lazyload">
                          </template>
                          <template v-else>
                            <div class="flex items-center justify-center w-56 h-56 bg-black-100 m-r-16 rounded-8">
                              <svg class="text-black-200 w-20 h-20 fill-current">
                                <use xlink:href="#page"></use>
                              </svg>
                            </div>
                          </template>
                          <div class="flex flex-col justify-center">
                            <h4 class="text-xs text-black-300">
                              {{ extra.tag }}
                              <template v-if="extra.type">
                                &nbsp;•&nbsp;<span class="font-normal">{{ extra.type }}</span>
                              </template>
                            </h4>
                            <h3 class="font-semibold text-lg leading-tight text-black-500">
                              {{ extra.title }}
                            </h3>
                          </div>
                        </a>
                      </li>
                    </template>
                  </ul>
                </div>
              </template>
              <template v-if="items.article">
                <div class="block relative">
                  <div class="flex flex-row justify-between items-center">
                    <div class="block relative">
                      <h3 class="font-display text-lg font-semibold">
                        Articoli
                      </h3>
                      <p class="text-micro text-black-300">{{ items.article.length }} record {{
                          finded(items.article.length)
                        }}</p>
                    </div>
                    <a class="lpbutton lpbutton-white lpbutton-xs"
                       :href="link">
                      Mostra tutti i risultati
                    </a>
                  </div>
                  <ul class="m-t-6">
                    <li v-for="article in items.article.slice(0,5)"
                        :key="article.id"
                        class="w-full p-x-12 p-y-16 text-left border-b-1 border-black-200">
                      <article class="flex items-center">
                        <div class="flex-1 flex flex-col flex-wrap justify-center">
                          <template v-if="article.inspiration">
                            <a :href="article.inspiration.link"
                               rel="nofollow"
                               class="block text-xs font-semibold m-b-2 text-blue-500 overflow-hidden">
                              {{ article.inspiration.label }}
                            </a>
                          </template>
                          <h4 class="text-xs text-blue-500 m-b-2">
                            {{ article.section }}
                          </h4>
                          <h3 class="font-semibold p-r-40 leading-tight text-base m-b-2">
                            <a :href="article.link"
                               class="block">
                              {{ article.title }}
                            </a>
                          </h3>
                          <h5 class="text-xs text-black-300">
                            {{
                              article.reading_time
                            }}&nbsp;•&nbsp;<span class="font-normal">{{ article.published_at_formatted }}</span>
                          </h5>
                        </div>
                        <div class="w-64 h-64 max-w-64">
                          <a :href="article.link" class="block relative w-full h-full">
                            <img :data-src="article.image"
                                 :alt="article.caption"
                                 class="w-full h-full shadow-md object-cover rounded-8 lazyload">
                          </a>
                        </div>
                      </article>
                    </li>
                  </ul>
                </div>
              </template>
              <template v-if="items.place || items.poi">
                <div class="block relative">
                  <div class="flex flex-row justify-between items-center">
                    <div class="block relative">
                      <h3 class="font-display text-lg font-semibold">
                        Destinazioni e POI
                      </h3>
                      <p class="text-micro text-black-300">{{
                          (items.place ? items.place.length : null) + (items.poi ? items.poi.length : null)
                        }} record {{
                          finded((items.place ? items.place.length : null) + (items.poi ? items.poi.length : null))
                        }}</p>
                    </div>
                    <a class="lpbutton lpbutton-white lpbutton-xs"
                       :href="link">
                      Mostra tutti i risultati
                    </a>
                  </div>
                  <ul class="m-t-6">
                    <template v-if="items.place">
                      <li v-for="place in items.place.slice(0,3)"
                          :key="place.id"
                          class="w-full p-x-12 p-y-16 text-left border-b-1 border-black-200">
                        <a :href="place.link"
                           target="_blank"
                           class="relative flex flex-row">
                          <template v-if="place.image">
                            <img :data-src="place.image"
                                 :alt="place.caption"
                                 class="float-left object-cover object-position-center w-56 h-56 max-w-56 m-r-16 rounded-8 lazyload">
                          </template>
                          <template v-else>
                            <div class="flex items-center justify-center w-56 h-56 bg-black-100 m-r-16 rounded-8">
                              <svg class="text-black-200 w-20 h-20 fill-current">
                                <use xlink:href="#location"></use>
                              </svg>
                            </div>
                          </template>
                          <div class="flex flex-col justify-center">
                            <h4 class="text-xs text-black-300 m-b-2">
                              {{ place.type }}
                              <template v-if="place.parent">
                                &nbsp;•&nbsp;<span class="font-normal">{{ place.parent }}</span>
                              </template>
                            </h4>
                            <h3 class="font-semibold text-base leading-tight text-black-500">{{ place.name }}</h3>
                          </div>
                        </a>
                      </li>
                    </template>
                    <template v-if="items.poi && (items.place ? items.place.length < 3 : true)">
                      <li v-for="poi in items.poi.slice(0,(items.place ? 3-items.place.length : 3))"
                          :key="poi.id"
                          class="w-full p-x-12 p-y-16 text-left border-b-1 border-black-200">
                        <a :href="poi.link"
                           target="_blank"
                           class="relative flex flex-row">
                          <template v-if="poi.image">
                            <img :data-src="poi.image"
                                 :alt="poi.caption"
                                 class="float-left object-cover object-position-center w-56 h-56 max-w-56 m-r-16 rounded-8 lazyload">
                          </template>
                          <template v-else>
                            <div class="flex items-center justify-center w-56 h-56 bg-black-100 m-r-16 rounded-8">
                              <svg class="text-black-200 w-20 h-20 fill-current">
                                <use :xlink:href="'#' + poi.tag"></use>
                              </svg>
                            </div>
                          </template>
                          <div class="flex flex-col justify-center">
                            <h4 class="text-xs text-black-300 m-b-2">
                              <template v-if="poi.type">
                                {{ poi.type }}
                              </template>
                              <template v-else>
                                {{ poi.ttd }}
                              </template>
                              &nbsp;•&nbsp;
                              <span class="font-normal">{{ poi.parent }}</span>
                            </h4>
                            <h3 class="font-semibold text-base leading-tight text-black-500">{{ poi.name }}</h3>
                          </div>
                        </a>
                      </li>
                    </template>
                  </ul>
                </div>
              </template>
            </div>
          </transition>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

import slugify from 'slugify'

export default {
  inherit: true,
  name: 'NavSearch',
  data() {
    return {
      show: false,
      searchInput: '',
      loading: false,
      items: [],
    }
  },
  computed: {
    link: function() {
      let query = 'q=' + slugify(this.searchInput, '+')
      return process.env.WWW_URL + '/ricerca?' + query
    },
  },
  methods: {
    async showSearch() {
      this.show = true
      this.$nextTick(() => {
        // this.getData()
        this.$refs.searchInput.focus()
      })
    },
    getSearchData: _.debounce(function() {
      if (this.searchInput && this.searchInput.length > 2) {
        this.loading = true
        let query = 'q=' + slugify(this.searchInput, '+')
        return axios.get(process.env.WWW_URL + '/api/search/smart?' + query).then(response => {
          if (response.status === 200) {
            this.items = response.data.items
          }
        }).catch().finally(() => {
          this.loading = false
        })
      }
    }, 600),
    handleSubmit() {
      let query = slugify(this.searchInput, '+')
      window.location.href = process.env.WWW_URL + '/ricerca?q=' + query
    },
    finded(length) {
      return length > 1 ? 'trovati' : 'trovato'
    },
  },
}

</script>
